/**
 * 뷰 모드 상수 정의
 * 작업자: 젠이츠
 */

export const VIEW_MODES = {
    TABLE_VIEW: "tableView",
    TILE_VIEW: "tileView",
    ORG_CHART: "org-chart",
    FLOW_CHART: "flow-chart",
    PATTERN_CHART: "pattern-chart",
    SCATTER_CHART: "scatter-chart",
    STACK_CHART: "stack-chart",
    EQUIP_CHART: "equip-chart",
    PROP_CHART: "prop-chart",
    DATA_BASE: "data-base",
};

/**
 * 뷰 모드 배열 (순서 중요)
 */
export const VIEW_MODE_LIST = [
    VIEW_MODES.TABLE_VIEW,
    VIEW_MODES.TILE_VIEW,
    VIEW_MODES.ORG_CHART,
    VIEW_MODES.FLOW_CHART,
    VIEW_MODES.PATTERN_CHART,
    VIEW_MODES.SCATTER_CHART,
    VIEW_MODES.STACK_CHART,
    VIEW_MODES.EQUIP_CHART,
    VIEW_MODES.PROP_CHART,
];

/**
 * 뷰 모드가 합계 노드를 지원하는지 확인
 */
export const isSumNodeSupportedView = (viewMode) => {
    return [
        VIEW_MODES.ORG_CHART,
        VIEW_MODES.FLOW_CHART,
        VIEW_MODES.PATTERN_CHART,
        VIEW_MODES.SCATTER_CHART,
        VIEW_MODES.STACK_CHART,
    ].includes(viewMode);
};

/**
 * 뷰 모드가 트렌드 차트를 지원하는지 확인
 */
export const isTrendChartView = (viewMode) => {
    return [VIEW_MODES.EQUIP_CHART, VIEW_MODES.PROP_CHART].includes(viewMode);
};
